import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { DWS } from '@interfaces/dws';
import { resource } from '@util/resource';
import * as moment from 'moment';

@Injectable({
  providedIn: 'root'
})
export class ProductStorageService {
  get(productId: string, storageId?: string): Observable<DWS.ProductStorage> {
    return resource(`crm://products/productId/storage`)
      .params({ storageId, productId })
      .get<DWS.ProductStorage>();
  }

  list(wineryId: string): Observable<DWS.ProductStorage[]> {
    return resource(`crm://products/storage/all`)
      .params({ wineryId })
      .get<DWS.ProductStorage[]>();
  }

  createOrActivate(productId: string, storageId?: string): Observable<DWS.ProductStorage> {
    return resource(`crm://products/productId/storage`)
      .params({ productId })
      .post<DWS.ProductStorage>({ storageId });
  }

  deactivate(productId: string, storageId?: string): Observable<void> {
    return resource(`crm://products/productId/storage`)
      .params({ productId, storageId })
      .delete();
  }

  executeAction(
    productId: string,
    delta: number,
    action: 'PURCHASE' | 'LOAD' | 'UNLOAD' | 'ADJUSTMENT',
    date: Date,
    storageId?: string
  ): Observable<DWS.ProductStorage> {
    return resource(`crm://products/productId/storage/action`)
      .params({ productId, action })
      .post<DWS.ProductStorage>({ storageId, delta, date: moment(date).format('YYYY-MM-DD') });
  }
}